var ProductColorAttributeCode;
(function (ProductColorAttributeCode) {
    // If you add a new color attribute here, you should also add it to the colorCodesList in src/components/Product/ConfigurableProduct/OptionsForm/constants.ts
    ProductColorAttributeCode["Color"] = "color";
    ProductColorAttributeCode["ColorLinen"] = "color_linen";
    ProductColorAttributeCode["ColorHeadboard"] = "headboard_color";
    ProductColorAttributeCode["ColorClothes"] = "clothes_color";
    ProductColorAttributeCode["ColorClothe"] = "color_clothes";
    ProductColorAttributeCode["ColorBed"] = "color_bed";
})(ProductColorAttributeCode || (ProductColorAttributeCode = {}));
var StockStatus;
(function (StockStatus) {
    StockStatus["OutOfStock"] = "OUT_OF_STOCK";
    StockStatus["InStock"] = "IN_STOCK";
})(StockStatus || (StockStatus = {}));
var BackorderStatus;
(function (BackorderStatus) {
    BackorderStatus["Allow"] = "Allow Qty Below 0";
    BackorderStatus["AllowAndNotify"] = "Allow Qty Below 0 and Notify Customer";
    BackorderStatus["Deny"] = "No Backorders";
})(BackorderStatus || (BackorderStatus = {}));
var ProductType;
(function (ProductType) {
    ProductType["Simple"] = "simple";
    ProductType["Configurable"] = "configurable";
    ProductType["Allow"] = "Allow";
})(ProductType || (ProductType = {}));
var ProductTypeRate;
(function (ProductTypeRate) {
    ProductTypeRate["Items"] = "items";
    ProductTypeRate["Bed"] = "bed";
    ProductTypeRate["Mattress"] = "mattress";
})(ProductTypeRate || (ProductTypeRate = {}));

export { BackorderStatus as B, ProductColorAttributeCode as P, StockStatus as S, ProductType as a, ProductTypeRate as b };
//# sourceMappingURL=product-_pRduMz7.js.map
